
import styled from "@emotion/styled";
import { ThemeStyle } from "assets/scss/common/theme";


export const Style = styled.div`
  border-radius: ${({ theme }: ThemeStyle) => theme.borders.radiusPrimary};
  border-style: solid;
  border-width: 1px;
  padding: 10px;

  &.new-msg-card {
    border-radius: ${({ theme }: ThemeStyle) => theme.borders.radiusPrimary};
  }

  &.warn-card {
   background-color:${({ theme }: ThemeStyle) => theme.warn.bg};
   border-color: ${({ theme }: ThemeStyle) => theme.warn.border};
  }
  
  &.error-card {
    background-color:${({ theme }: ThemeStyle) => theme.error.bg};
    border-color: ${({ theme }: ThemeStyle) => theme.error.border};
  }
  
  &.info-card {
    background: rgba(56,141,255,0.08);
    border-color: rgba(56,141,255,0.16);
  }

  &.success-card {
    background-color:${({ theme }: ThemeStyle) => theme.success.bg};
    border-color: ${({ theme }: ThemeStyle) => theme.success.border};
    padding: 5px;
  }

  @media (min-width: 1140px) {
    border-radius: ${({ theme }: ThemeStyle) => theme.borders.radiusPrimary};
  }
`;


export const Message = styled.div`
   color: ${({ theme }: ThemeStyle) => theme.colors.pebble900};
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`;

